import { useBreakpoint } from '@hooks/useBreakpoint'

export const useResponsiveLayout = () => {
  const isDesktop = useBreakpoint('md')
  const isTablet = useBreakpoint('sm') && !isDesktop

  return {
    isDesktop,
    isTablet,
    isMobile: !isDesktop && !isTablet,
  }
}
